import store from "@/store/store";
import moment from "moment";
import Vue from "vue";
import { eventBus } from "../main";
import { createTeleInterconsultLog } from "../services/teleinterconsult_log";
import { formatRut } from "../services/utils";
import lodash, { capitalize } from "lodash";
import ModalDifferencesPatientFonasa from "@/components/interoperability/modalDifferencesPatientFonasa/ModalDifferencesPatientFonasa.vue";
import { PatientService } from "@/services/models/patient";
import { FonasaValidationService } from "@/servicesTs/models/general/fonasaValidation";
import { FonasaValidationHistoryService } from "@/servicesTs/models/general/fonasaValidationHistory";

export const myMixin = {
  data() {
    return {
      profilesRequiredToValidate: [16],
    };
  },
  methods: {
    checkAccess(criteria) {
      // 1. Verificamos si el perfil actual (obtenido en el mixin) requiere validación estricta
      const currentRoleId = this.getCurrentRoleId();
      const requiresValidation = this.profilesRequiredToValidate.includes(currentRoleId);
      // Si NO está en la lista, es un perfil que aun no funciona con permisos: pasa directo sin mirar Vuex
      if (!requiresValidation) {
        return true;
      }

      // 3. Llamamos al getter de Vuex directamente.
      // NOTA: Si tu store usa módulos, recuerda anteponer el nombre del módulo (ej: 'auth/hasPermission')
      const hasPermissionGetter = this.$store.getters["userSession/hasPermission"];

      if (typeof hasPermissionGetter !== "function") {
        console.warn("[PermissionMixin] El getter 'hasPermission' no fue encontrado en Vuex.");
        return false;
      }

      // Ejecutamos el método que retorna el getter pasándole los criterios
      return hasPermissionGetter(criteria);
    },
    toast(message, type) {
      this.$buefy.toast.open({
        message: message,
        type: type,
        position: "is-top",
      });
    },
    getUrlFile(file_name) {
      return `${Vue.http.options.root}/api/visor/${file_name}`;
    },
    getCurrentUserLoggedIn() {
      return JSON.parse(window.localStorage.getItem("user"));
    },
    getCurrentStablishmentId() {
      return JSON.parse(window.localStorage.getItem("stablishment"));
    },
    storeTeleInterconsultLog(data) {
      createTeleInterconsultLog(this.$http, {
        ...data,
        user_id: this.getCurrentUserLoggedIn().id,
      });
    },
    getRutWithoutFormat(data) {
      let rut = data.replace(/[.-]/g, "");
      return rut;
    },
    processPatientIdentifier(patient) {
      if (patient.rut) {
        return formatRut(patient.rut);
      } else if (patient.passport) {
        return patient.passport;
      } else if (patient.mother_rut) {
        return formatRut(patient.mother_rut);
      } else if (patient.other_identification) {
        return patient.other_identification;
      } else if (patient.provisional_rut) {
        return formatRut(patient.provisional_rut);
      }
    },
    formatDate(date) {
      let result = date.split(" ");
      let newDate;
      if (result.length == 2) {
        newDate = moment(date).format("DD-MM-YYYY HH:mm");
      } else {
        newDate = moment(date).format("DD-MM-YYYY");
      }
      return newDate;
    },
    showDate(date) {
      let dateDifferenceInDays = moment().diff(moment(date), "days", false);
      let formattedDate = moment(date).format("DD-MM-YYYY");
      let daysText = dateDifferenceInDays == 1 ? "día" : "días";
      let textDifference = dateDifferenceInDays == 0 ? "Hoy" : `Hace ${dateDifferenceInDays} ${daysText}`;
      return `${formattedDate} (${textDifference})`;
    },
    /**
     *
     * @param {String} type tipo de toast(success,warning,error,info)
     * @param {String} title
     * @param {String} message
     */
    showToast(type, title, message, milliseconds = 5000) {
      let data = {
        type,
        title,
        message,
        milliseconds,
      };
      eventBus.$emit("loadToast", data);
    },
    /**
     *
     * @param {Object} data
     * data = {
     *   type: ["success","warning","error","info"]
     *   title: string
     *   message: string
     * }
     */
    displayToast(data) {
      this.$store.commit("toast/showToast", data);
    },
    /**
     *
     * @param {string} date formato DD-MM-YYYY
     * @returns
     */
    calculateAge(date) {
      let now = moment();
      let birth_date = moment(date, "DD-MM-YYYY");
      let result = now.diff(birth_date, "years");
      return result;
    },
    displayLoader(data) {
      store.commit("loader/setLoader", data);
    },
    //Esto es para dejar la primera letra en mayuscula y el resto en minuscula
    firstLetterCapitalize(word) {
      return capitalize(word);
    },
    stateInterconsult(interconsult) {
      let estadoInterconsulta = "Sin Información";
      if (interconsult.contrarrefs.length > 0) {
        estadoInterconsulta = "Egresada";
      } else if (interconsult.schedules_citations?.length > 0) {
        let valorArray = interconsult.schedules_citations?.length - 1;
        estadoInterconsulta =
          interconsult.schedules_citations[valorArray]?.state.charAt(0).toUpperCase() + interconsult.schedules_citations[valorArray]?.state.slice(1);
      } else {
        if (interconsult.states_interconsults.length != 0) {
          let valorArrayStatesInterconsults = interconsult.states_interconsults?.length - 1;
          estadoInterconsulta =
            interconsult.states_interconsults[valorArrayStatesInterconsults]?.state.charAt(0).toUpperCase() +
            interconsult.states_interconsults[valorArrayStatesInterconsults]?.state.slice(1);
        } else if (interconsult.state === "active") {
          estadoInterconsulta = "Creada";
        } else {
          estadoInterconsulta = interconsult.state.charAt(0).toUpperCase() + interconsult.state.slice(1);
        }
      }
      if (estadoInterconsulta == "Rechazada pendiente") {
        estadoInterconsulta = "Egresada";
      }
      return estadoInterconsulta;
    },
    haveNumbers(texto) {
      let numbers = "0123456789";
      for (let i = 0; i < texto.length; i++) {
        if (numbers.indexOf(texto.charAt(i), 0) !== -1) {
          return true;
        }
      }
      return false;
    },
    haveLowerCase(texto) {
      let letters = "abcdefghyjklmnñopqrstuvwxyz";
      for (let i = 0; i < texto.length; i++) {
        if (letters.indexOf(texto.charAt(i), 0) !== -1) {
          return true;
        }
      }
      return false;
    },
    haveUpperCase(texto) {
      let letters = "ABCDEFGHYJKLMNÑOPQRSTUVWXYZ";
      for (let i = 0; i < texto.length; i++) {
        if (letters.indexOf(texto.charAt(i), 0) !== -1) {
          return true;
        }
      }
      return false;
    },
    hasSpecialCharacters(str) {
      const regex = /[!@#$%^&*(),.?":{}|<>]/g;
      return regex.test(str);
    },
    proccessPatientFileNumber(patient) {
      if (this.getCurrentStablishmentId() == 1803) {
        return patient.file_number_hae;
      } else if (patient.file_number) {
        return patient.file_number;
      } else {
        ("Sin Registro");
      }
    },

    copyPaste(text) {
      const el = document.createElement("textarea");
      el.value = text;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);

      el.select();
      document.execCommand("copy");

      document.body.removeChild(el);
      this.displayToast({
        type: "info",
        title: "Copiado",
        message: "Información copiada",
      });
    },
    getCurrentRoleId() {
      return JSON.parse(window.localStorage.getItem("role_id"));
    },
    async comparateDataPatientWithFonasa(data_patient) {
      if (data_patient.latest_fonasa_validation && data_patient.latest_fonasa_validation.state == "active") {
        // EN CASO DE QUE EXISTAN CAMPOS DISTINTOS A LOS DE FONASA, EXCLUYENDO PRAIS, FECHA DE NACIMIENTO, O CELULAR, SE ABRIRÁ EL MODAL
        let stablishmentId = JSON.parse(window.localStorage.getItem("stablishment"));
        if (stablishmentId == "5051") {
          this.$buefy.modal.open({
            parent: this,
            component: ModalDifferencesPatientFonasa,
            hasModalCard: true,
            props: {
              patient_data: data_patient,
              fonasa_data: data_patient.latest_fonasa_validation,
            },
            trapFocus: true,
          });
        }
      }
    },
    soloNumeros(event) {
      const teclasPermitidas = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];
      const esNumero = /^[0-9]$/;

      if (!esNumero.test(event.key) && !teclasPermitidas.includes(event.key)) {
        event.preventDefault();
      }
    },
    waitFor(conditionFn, interval = 100, timeout = 5000) {
      return new Promise((resolve, reject) => {
        const start = Date.now();

        const check = () => {
          if (conditionFn()) {
            resolve(true);
          } else if (Date.now() - start >= timeout) {
            reject(new Error("Timeout esperando condición"));
          } else {
            setTimeout(check, interval);
          }
        };

        check();
      });
    },
    calculateAgeBreakdown(date) {
      let dateRequest = moment(date, "DD-MM-YYYY");
      let todayDate = moment(new Date(), "DD-MM-YYYY"); //Can change, based on the requirement
      let diffTime = moment(todayDate).diff(dateRequest);

      let duration = moment.duration(diffTime);
      let years = duration.years();
      let days = duration.days();
      let months = duration.months();
      return `${years} a, ${months} m, ${days} d`;
    },
    getGesSIC(interconsult) {
      let response = null;
      if (interconsult.cie10_category) {
        response = interconsult.cie10_category.auge;
      } else if (interconsult.cie10_sub_category) {
        response = interconsult.cie10_sub_category.auge;
      }
      return response;
    },
    /**
     * @param {object} params
     * @param {object} [params.object={}]
     * @param {'primario' | 'secundario' | 'terciario'} [params.priority='primario']
     * @param {string} params.type
     * @returns {string | null} Formato: "CIE10 - DIAGNÓSTICO" o null
     */
    showCie10Category({ object = {}, priority = "primario", type }) {
      const isInterconsult = type === "interconsult";

      const keyMap = {
        primario: {
          cat: "cie10_category",
          subCat: "cie10_sub_category",
          fallback: isInterconsult ? null : "cie_10_1",
        },
        secundario: { cat: "cie10_secondary_category", subCat: "cie10_secondary_sub_category", fallback: "cie_10_2" },
        terciario: { cat: "cie10_terciary_category", subCat: "cie10_terciary_sub_category", fallback: "cie_10_3" },
      };

      const keys = keyMap[priority];
      if (!keys) return null;

      let cie10 = null;
      let diagnostic = null;

      // 1. Validar si existe la categoría o subcategoría
      const entity = object[keys.cat] || object[keys.subCat];
      if (entity) {
        cie10 = entity.id ?? null;
        diagnostic = entity.name ?? null;
      }
      // 2. Fallback específico para interconsult
      else if (isInterconsult && priority === "primario") {
        cie10 = object.cie_10?.replace(".", "").trim() ?? null;
        diagnostic = object.diagnostic ?? null;
      }
      // 3. Fallback genérico con formato "CÓDIGO-DIAGNÓSTICO"
      else if (object[keys.fallback]) {
        const [code = "", name = ""] = object[keys.fallback].split("-");
        cie10 = code.replace(".", "").trim();
        diagnostic = name.trim() || null;
      }

      // Si no hay ninguno de los dos valores, retornar null
      if (!cie10 && !diagnostic) return null;

      // Retornar concatenado respetando casos donde falte alguno de los dos valores
      if (cie10 && diagnostic) return `${cie10}-${diagnostic}`;
      return cie10 || diagnostic;
    },
  },
};
function getNestedValue(obj, path) {
  return path.split(".").reduce((o, p) => (o ? o[p] : undefined), obj);
}
function normalizeValue(value) {
  if (value == null) return ""; // si es null o undefined
  return value
    .toString()
    .normalize("NFD") // separa tildes
    .replace(/[\u0300-\u036f]/g, "") // elimina tildes
    .toLowerCase()
    .trim();
}
